export default __webpack_public_path__ + "images/bdbda2697aa55acc1038df6448331599.png";